import 'view/css/report.css';

// eslint-disable-next-line
import { Chart as ChartJS } from 'chart.js/auto';   // cannot remove, this 2 lines will register scale for ChartJS
// eslint-disable-next-line
import { Chart }            from 'react-chartjs-2';

import { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';

import Util, { Data } from 'service/util';
import Loading from 'component/Loading';

const ProfitReportViewContent = ({ data }) =>
{

  const [mode, setMode] = useState('mgt');

  const [ls_dis, setDistrictList]   = useState([]);
  const [ls_mgt, setManagementList] = useState([]);
  const [ls_loc, setLocationList]   = useState([]);

  const [company, setCompany ] = useState(Data.company[0].cd);
  const [dis,     setDistrict] = useState('');
  const [loc,     setLocation] = useState('');

  const [chartData, setChartData] = useState(null);

  // -- functions
  const updateSelectionList = () =>
  {
    if (!data) {
      setDistrictList([]);
      setManagementList([]);
      setLocationList([]);
      return false;
    }

    // capture all districts and location key
    let _ref_dis = new Set();
    let _ref_mgt = new Set();
    let _ref_loc = new Set();
    for (let i = 0; i < data[company].datasets.length; i++)
    {
      let D = data[company].datasets[i].data;
      for (let j = 0; j < D.length; j++)
      {
        Object.keys(D[j].srv_dis).forEach(dis_key => _ref_dis.add(dis_key));
        Object.keys(D[j].mgt_dis).forEach(mgt_key => _ref_mgt.add(mgt_key));
        Object.keys(D[j].locations).forEach(loc_key => _ref_loc.add(loc_key));
      }
    }

    // convert district / management zone key
    let _ls_dis = Array.from(_ref_dis).map(dis_key => {
      let _dist = Data.district.find(d => d.cd == dis_key);
      if (!_dist) return { cd: dis_key, name: `${dis_key} - Unknown` };
      return { cd: _dist.cd, name: `${_dist.cd} - ${_dist.name}` };
    });

    let _ls_mgt = Array.from(_ref_mgt).map(mgt_key => (
      { cd: mgt_key, name: mgt_key }
    ));

    // convert location key to location detail
    let colKey = { dis: 'srv_dis', mgt: 'mgt_dis' }[mode];
    let L = Data.location.filter(l => l[colKey] == dis);
    let _ls_loc = L.filter(l => _ref_loc.has(`${l.srv_dis}${l.srv_loc}`))
      .map(l => ({cd: `${l.srv_dis}${l.srv_loc}`, name: `${l.name_zh} ${l.name_en}`}));

    // update and render
    setDistrictList(_ls_dis);
    setManagementList(_ls_mgt);
    setLocationList(_ls_loc);
  }

  const loadChartData = () =>
  {
    if (!data?.[company]) return setChartData(null);

    let colKey = { dis: 'srv_dis', mgt: 'mgt_dis' }[mode];

    // deep clone
    let raw = JSON.parse(JSON.stringify(data[company]));
    for (let dsi = 0; dsi < raw.datasets.length; dsi++)
    {
      raw.datasets[dsi].data = raw.datasets[dsi].data.map(x => {
        /* all       */ if (!dis) return x.total;
        /* districts */ if (!loc) return x[colKey][dis];
        /* locations */ return x.locations[loc];
      });
    }
    setChartData(raw);
  };

  // --
  useEffect(() => {
    if (data) {
      updateSelectionList(data);
      loadChartData();
    } else {
      setChartData(null);
    }
  }, [data]);

  useEffect(() => { setDistrict('') }, [mode]);
  useEffect(() => { setLocation('') }, [dis]);

  useEffect(() => {
    updateSelectionList();
    loadChartData();
  }, [company, mode, dis, loc]);

  // filter
  if (!data) return <Loading />
  if (!data[company]) return <p className="message red">沒有此公司資料。</p>
  if (!chartData) return <Loading />

  return (<>
    <div className="search-bar">
      <label className="field-row">
        <strong>公司</strong>
        <select value={company} onChange={e=>setCompany(e.target.value)}>
          { Data.company.map(com =>
            <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
          )}
        </select>
      </label>
      <label className="field-row">
        <strong>模式</strong>
        <select value={mode} onChange={e=>setMode(e.target.value)}>
          <option value="dis">地區</option>
          <option value="mgt">管轄區</option>
        </select>
      </label>
      <label className="field-row">
        <strong></strong>
        <select value={dis} onChange={e=>{ setDistrict(e.target.value); setLocation(''); }}>
          <option value="">全部</option>
          { { dis: ls_dis, mgt: ls_mgt }[mode].map(d =>
            <option key={d.cd} value={d.cd}>{d.name}</option>
          )}
        </select>
      </label>
      { !!dis &&
        <label className="field-row">
          <strong>屋苑</strong>
          <select value={loc} onChange={e=>setLocation(e.target.value)}>
            <option value="">全部</option>
            { ls_loc.map(l =>
              <option key={l.cd} value={l.cd}>{l.cd} - {l.name}</option>
            )}
          </select>
        </label>
      }
    </div>
    <div className="chart-container">
      <Bar data={chartData} options={{
         responsive: true
        ,maintainAspectRatio: false
        ,plugins: {
          title: {
            display: true,
            text: '過去十四個月營業額統計',
            fontSize: 20
          },
        }
      }}/>
    </div>
    <table id="profit-table">
      <thead>
        <tr>
          <th>月份</th>
          <th>{ chartData.datasets[0].label }</th>
          <th>{ chartData.datasets[1].label }</th>
          <th>{ chartData.datasets[2].label }</th>
          <th>{ chartData.datasets[3].label }</th>
        </tr>
      </thead>
      <tbody>
      {data[company].labels.map((lbl, i) =>
        <tr key={lbl}>
          <th>{lbl}</th>
          <td>{Util.nf2(chartData.datasets[0].data[i])}</td>
          <td>{Util.nf2(chartData.datasets[1].data[i])}</td>
          <td>{Util.nf2(chartData.datasets[2].data[i])}</td>
          <td>{Util.nf2(chartData.datasets[3].data[i])}</td>
        </tr>
      )}
      </tbody>
    </table>
  </>);

}

export default ProfitReportViewContent;